/**
 * Word-by-word captions for the tour slide. The narration's word timings ({w, s, e} in seconds) come from the
 * same text-to-speech call that made the audio, so the highlighted word follows the tutor's voice.
 */

/** Index of the word being spoken at `time` seconds: the last word that has started, or -1 before the first. */
export function currentWordIndex(words, time) {
  if (!Array.isArray(words) || !words.length || !(time >= 0)) return -1;
  let low = 0;
  let high = words.length - 1;
  let found = -1;
  while (low <= high) {
    const mid = (low + high) >> 1;
    if (words[mid].s <= time) {
      found = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  return found;
}

/** Splits the words into sentences (a word ending in . ! or ? closes one). */
export function sentences(words) {
  const out = [];
  let current = [];
  (words || []).forEach((word, index) => {
    current.push({...word, index});
    if (/[.!?]["')\]]*$/.test(word.w)) {
      out.push(current);
      current = [];
    }
  });
  if (current.length) out.push(current);
  return out;
}

/** The sentence holding word `index` (the first sentence before the narration starts). */
export function sentenceAt(words, index) {
  const all = sentences(words);
  if (!all.length) return [];
  return all.find(sentence => sentence.some(word => word.index === index)) || all[0];
}
